export enum enumDLIDocumentTemplates {
	'SB_Application_FullFICA',
	'SB_Application_ Ex17',
	'SB_Application_CellBankService',
	'SB_Reissue',
	'SB_Request_SalaryInstruction',
	'SB_Upgrade_ToEx17',
	'SB_Upgrade_ToFF',
	'SB_Termination_FuneralCover',
	'SMS Printer Merchant Receipt',
	'Incoming credit SMS',
	'CellBank Credit SMS',
	'ACB Debit SMS',
	'MobileBanking TRF SMS',
	'SMS Change Classification',
	'SB_AccountPack',
	'SB_Application_FurenalBenefit',
	'SB_Certificate_FuneralPlan',
	'OnlineBanking Credit SMS',
	'Card Transaction SureCard',
	'Send OTP SMS',
	'SureCard Credit Received SMS',
	'Portal Debit SMS',
	'Wizzit Credit SMS',
	'Wizzit Debit SMS',
	'AUTHORITY AND MANDATE FOR PAYMENT INSTRUCTIONS',
	'EDCON Successful',
	'EDCON Unsuccessful',
	'Online Banking T&C',
	'World Check Verification',
	'Compuscan Verification',
	'Reply to SMS',
	'Auth SMS',
	'SureCard SMS',
	'mediBucks ReplyTo',
	'mediBucks Successful',
	'mediBucks Unsuccessful',
	'mediBucks Floorlimit',
	'SureCard Welcome SMS',
	'mediBucks_welcome',
	'Mobile Banking Registration SMS',
	'Mobile OTP Reset SMS',
	'mediBucks ACB Credit',
	'AuthLoadedChangeMobileNo Email',
	'AuthLoadedResetOTP Email',
	'Mobile Banking AuthCode SMS',
	'Mobile Banking AuthCode Email',
	'Mobile Banking Service',
	'FICA_accepted_SC',
	'FICA_accepted_Wizzit',
	'FICA_accepted_mB',
	'WIZZIT Welcome',
	'Card Transaction Wizzit',
	'SureCard DC Transaction',
	'Premium Welcome SMS',
	'FICA Accepted Premium',
	'SureCard eCommerce',
	'Wizzit eCommerce',
	'SAFPS NPR Enquiry',
	'SAFPS NIIS Enquiry',
	'mB Mobile Banking Registration',
	'mB Eduvos Welcome',
	'mB Eduvos FICA',
	'Eduvos Credit Received',
	'Mafori Welcome SMS',
	'FICA_accept_MF',
	'Mafori_salary',
	'Mafori Debit SMS',
	'Mafori Credit SMS',
	'Card Transaction Mafori',
	'Mafori_Replace',
	'AM_Confirmation Letter',
	'IP_Confirmation Letter',
	'Card Error SMS CB',
	'Error SMS',
	'Cash Access Loaded',
              }
              
              export namespace enumDLIDocumentTemplates {
	export function values() {
	  return Object.keys(enumDLIDocumentTemplates).filter(
	    (type) => isNaN(<any>type) && type !== 'values'
	  );
	}
              }
              